// USD amounts verified against these Stripe prices on October 7, 2026.
// Billing periods are choices within Pro or Max, not separate feature tiers.
export const SUBSCRIPTION_TIERS = [
  {
    id: 'pro', name: 'Pro', description: 'For everyday Chat',
    benefits: ['All Chat models', 'Unlimited standard-model messages', 'Ad-free experience'],
    note: 'Some models have usage limits. Work is included with Max.',
    prices: [
      { label: 'Annual', period: 'year', amount: 15299, priceId: 'price_1QwudoApEIymxqdxSp90tElY' },
      { label: 'Monthly', period: 'month', amount: 1499, priceId: 'price_1QwucrApEIymxqdxxFWJqOSQ' },
      { label: 'Weekly', period: 'week', amount: 799, priceId: 'price_1QwubYApEIymxqdxgQhLv15B' },
    ],
  },
  {
    id: 'max', name: 'Max', description: 'Chat + Work',
    benefits: ['Everything in Pro', 'Work for tasks and projects', 'Work credits included'],
    note: 'Work usage is limited by credits. Available in the Mac app.',
    prices: [
      { label: 'Annual', period: 'year', amount: 32999, priceId: 'price_1UO76yApEIymxqdxUCoxomZa' },
      { label: 'Monthly', period: 'month', amount: 2999, priceId: 'price_1UK2lQApEIymxqdx9urj7ebg' },
      { label: 'Weekly', period: 'week', amount: 1599, priceId: 'price_1UO76EApEIymxqdxb8QBUvti' },
    ],
  },
];

export const formatPrice = cents => new Intl.NumberFormat('en-US', {
  style: 'currency', currency: 'USD',
}).format(cents / 100);

export const annualSavings = tier => {
  const annual = tier.prices.find(price => price.period === 'year');
  const monthly = tier.prices.find(price => price.period === 'month');
  return Math.max(0, Math.round((1 - annual.amount / (monthly.amount * 12)) * 100));
};
